export default __webpack_public_path__ + "static/media/vqa_noimg_en.8ab39cb1.jpg";